/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'ai-mate.agent-header-banner-label': 'Agentbanner',
  'ai-mate.agent-list.all-agents-section-title': 'Alle agenter',
  'ai-mate.agent-list.beta-lozenge-title': 'Beta',
  'ai-mate.agent-list.change-owner-success-flag-description': 'Du endret eieren av {agentName} til {newOwnerName}',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Eieren er endret',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Er du sikker på at du vil slette denne agenten? Denne handlingen kan ikke angres.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Vil du slette «{agentName}»?',
  'ai-mate.agent-list.delete-agent-error': 'Kan ikke slette agenten',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Noe gikk galt under sletting av agenten. Prøv igjen om en liten stund.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Kan ikke slette agent',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': 'Agenten er i bruk. Prøv igjen senere.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Vi finner ikke den agenten.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'Du kan ikke slette agenter du ikke har opprettet selv. Kontakt agenteieren.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Du slettet {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agenten er slettet',
  'ai-mate.agent-list.development-section-title': 'Utviklingsagenter',
  'ai-mate.agent-list.recommended-agents-section-title': 'Anbefalt',
  'ai-mate.agent-list.templates-description':
    'Bruk disse malene til å opprette din egen utvikleragent. Velg riktig agentmal for arbeidet ditt, velg Bruk mal, og fyll deretter ut ledeteksten for malen med spesifikke detaljer som repositorium, mappe, språk og bibliotek. Opprett skreddersydde utviklingsagenter for koding av forskjellige oppgaver, prosjekter eller repositorier.',
  'ai-mate.agent-list.templates-lozenge-title': 'Mal',
  'ai-mate.agent-list.templates-title': 'Kodemaler',
  'ai-mate.agent-message.agent-not-found': 'Finner ikke agenten',
  'ai-mate.agent-message.convo-title': 'Chat med {agentName} ble utløst fra innebygd smartkobling',
  'ai-mate.agent-message.copy-link': 'Kopier agentkobling',
  'ai-mate.agent-message.prompt': 'Ledetekst',
  'ai-mate.agent-message.prompt-placeholder': 'Skriv en melding til {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Send inn',
  'ai-mate.agent-message.view-profile': 'Vis profil',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Avbryt',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Slett',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Chat med {agentName}',
  'ai-mate.agent-profile-info.hidden-icon': 'Skjult',
  'ai-mate.agent-profile-info.hidden-tooltip': 'Agenten vises ikke i søkeresultatene',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Merk agent med stjerne',
  'ai-mate.agent-selector.default-agent-description':
    'Få svar, generer nye idéer og sett fart på det daglige arbeidet.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.profile-card-preview.actions-title': 'Tiltak',
  'ai-mate.profile-card-preview.agent-default-title': 'Agent',
  'ai-mate.profile-card-preview.agent-description-label': 'Beskrivelse',
  'ai-mate.profile-card-preview.agent-title-label': 'Tittel',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Samtalestartere',
  'ai-mate.profile-card-preview.empty-actions': 'Ingen',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Ingen',
  'ai-mate.profile-card-preview.empty-instructions': 'Ingen',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Ingen er valgt',
  'ai-mate.profile-card-preview.instructions-title': 'Instruksjoner',
  'ai-mate.profile-card-preview.knowledge-title': 'Kunnskap',
  'ai-mate.profile-card-preview.regenerate-label': 'Generer {fieldName} på nytt',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} – kopi',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Dra for å omorganisere',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Kan ikke lagre endringene',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Det oppstod en ukjent feil. Prøv på nytt',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'En agent med det navnet finnes allerede',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Fjern',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text': 'Generer samtalestartere',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} kan ikke overskride {maxLength,number} tegn} other {{fieldName} kan ikke overskride {maxLength,number} tegn}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Neste',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Start på nytt',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Hopp til manuell konfigurasjon',
  'create-agent.owner-field.confirm-modal-cancel': 'Avbryt',
  'create-agent.owner-field.confirm-modal-confirm': 'Ja, fortsett',
  'create-agent.owner-field.confirm-modal-content':
    'Du er i ferd med å endre eieren av denne agenten til {name}. Hvis du gjør dette, vil du ikke lenger kunne redigere eller administrere denne agenten.',
  'create-agent.owner-field.confirm-modal-title': 'Du er i ferd med å miste redigeringstilgang',
  'create-agent.owner-field.owner-description': 'Dette er personen som kan redigere eller administrere agenten.',
  'create-agent.owner-field.owner-label': 'Eier',
  'rovo-chat.agent-card.deactivated-name': '{name} (deaktivert)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'For mange forespørsler. Vent litt.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Prøv igjen',
  'rovo-chat.browse-agents.all-agents-button': 'Alle',
  'rovo-chat.browse-agents.close-button': 'Lukk',
  'rovo-chat.browse-agents.create-agent-button': 'Opprett',
  'rovo-chat.browse-agents.create-an-agent-button': 'Opprett agent',
  'rovo-chat.browse-agents.created-by-label': '<text>av</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Kodeagenter',
  'rovo-chat.browse-agents.favorite-agents-button': 'Favoritter',
  'rovo-chat.browse-agents.favourited-agent-label': 'Agent merket som favoritt',
  'rovo-chat.browse-agents.learn-more': 'Finn ut mer',
  'rovo-chat.browse-agents.modal-title': 'Bla gjennom agenter',
  'rovo-chat.browse-agents.my-agents-button': 'Mine agenter',
  'rovo-chat.browse-agents.no-created-agents':
    'Du har visst ikke opprettet noen agenter ennå. Begynn med å duplisere andre eksisterende agenter eller start fra bunnen av for å opprette en.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Ingen agenter er opprettet ennå',
  'rovo-chat.browse-agents.no-results': 'Ingen resultater',
  'rovo-chat.browse-agents.no-starred-agents':
    'Hvis du har en favorittagent eller en agent du bruker ofte, kan du merke den med stjerne så du har lett tilgang til den.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Du har ikke merket noen agenter med stjerne ennå',
  'rovo-chat.browse-agents.search-input.placeholder': 'Søk etter agenter',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Søk i maler',
  'rovo-chat.browse-agents.see-all-agents-button': 'Se alle agenter',
  'rovo-chat.browse-agents.starred-agents-button': 'Stjernemerket',
  'rovo-chat.browse-agents.templates-button': 'Maler',
  'rovo-chat.create-agent.actions-section-description':
    'Legg til handlinger så agenten kan utføre oppgaver i Jira, Confluence og Jira Service Management. <link>Hva er agenthandlinger?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Legg til handlinger',
  'rovo-chat.create-agent.all-content-label': 'Alt innhold',
  'rovo-chat.create-agent.back-button': 'Gå tilbake',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Du har ikke opprettet agenten ennå. Vil du forkaste den?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Avbryt',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Ja, forkast agenten',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Uferdig agent',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Er du sikker på at du vil slette endringene du gjorde i denne agenten?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Bekreft',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Start opprettingen på nytt',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Man kan bruke dette til å starte en chat med agenten din. Hvis du ikke kommer på noen, kan vi generere dem for deg.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Samtalestartere',
  'rovo-chat.create-agent.create-agent-button': 'Opprett',
  'rovo-chat.create-agent.ctions-section-title': 'Tiltak',
  'rovo-chat.create-agent.description-field-description':
    'Besøkende kan bruke beskrivelsen på agentens profil til å finne ut mer om den.',
  'rovo-chat.create-agent.description-field-label': 'Beskrivelse',
  'rovo-chat.create-agent.description-field-placeholder':
    'Skriv en kort beskrivelse om agenten (for eksempel kreativ skribent for markedsføringsblogger)',
  'rovo-chat.create-agent.instructions-field-description':
    'Hvordan vil du at denne agenten skal oppføre seg? Hva kan den gjøre? <link>Mer om å skrive instruksjoner for en agent</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Instruksjoner',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Tilpass instruksjonene for denne agenten',
  'rovo-chat.create-agent.intro-description-part-1':
    'Opprett en agent med spesialisert kunnskap som kan svare på spørsmål, skrive og gjennomgå innhold og utføre oppgaver for å hjelpe deg videre i arbeidet.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Hvis du ikke trenger hjelp, kan du <bold>hoppe til manuell konfigurasjon.</bold>',
  'rovo-chat.create-agent.intro-description-part-3': 'Ellers kan du bli her, så lager vi en sammen.',
  'rovo-chat.create-agent.intro-step-1-content':
    'Jeg setter opp instruksjoner for agenten basert på det du skriver. Bare fortell meg hva du planlegger å bruke agenten til.',
  'rovo-chat.create-agent.intro-step-1-title': 'Beskriv hva du vil at agenten skal gjøre',
  'rovo-chat.create-agent.intro-step-2-content':
    'Vi kan samarbeide om å bestemme agentens navn og personlighet. Si om agenten er medfølende, direkte eller morsom.',
  'rovo-chat.create-agent.intro-step-2-title': 'Legg til litt personlighet',
  'rovo-chat.create-agent.intro-step-3-content':
    'Trykk på <bold>Neste</bold> for å gjennomgå den nye agenten og legge til handlinger, kunnskap og et profilbilde. Når du er ferdig, velger du <bold>Opprett.</bold>',
  'rovo-chat.create-agent.intro-step-3-title': 'Gjennomgå og opprett agenten',
  'rovo-chat.create-agent.intro-title': '👋 Skal vi opprette en agent?',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Alle prosjekter',
  'rovo-chat.create-agent.knowledge-field-description':
    'Angi agentens kunnskap ved å kun la den referere til kildene du oppgir',
  'rovo-chat.create-agent.knowledge-field-label': 'Kunnskap',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Referer kun til disse kildene',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Forslag',
  'rovo-chat.create-agent.manage-actions-button-label': 'Administrer handlinger',
  'rovo-chat.create-agent.name-field-description': 'Man kan bruke dette til å finne agenten.',
  'rovo-chat.create-agent.name-field-label': 'Navn',
  'rovo-chat.create-agent.name-field-placeholder': 'Gi agenten et navn',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error': 'Det oppstod en uventet feil. Prøv på nytt.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Hei! Jeg er her for å hjelpe deg med å lage en egendefinert agent. Hva vil du at agenten skal gjøre?',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Skriv inn meldingen',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Send',
  'rovo-chat.create-agent.page-title': 'Opprett agent',
  'rovo-chat.create-agent.page-title-edit': 'Rediger agent',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Søk etter sider',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Søk etter områder',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Alle',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Beta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Avbryt',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Lukk',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Velg {count,number} handling for optimal ytelse} other {Velg færre enn {count,number} handlinger for optimal ytelse}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Lagre',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Søk etter handlinger',
  'rovo-chat.create-agent.select-action-modal-title': 'Legg til handlinger',
  'rovo-chat.create-agent.select-content-under-label': 'Velg innhold under',
  'rovo-chat.create-agent.select-spaces-label': 'Velg områder',
  'rovo-chat.create-agent.selected-actions-label': 'Valgte handlinger:',
  'rovo-chat.create-agent.unknown-owner': 'Ukjent',
  'rovo-chat.create-agent.update-agent-button': 'Oppdater',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Hvis du fortsetter, går ulagrede endringer tapt. Velg Avbryt for å fortsette å redigere denne agenten.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Fortsett, forkast endringer',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Forkast endringer',
  'rovo-chat.view-agent.about-label': 'Om',
  'rovo-chat.view-agent.actions-label': 'Tiltak',
  'rovo-chat.view-agent.beta-label': 'Beta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Chat med agent',
  'rovo-chat.view-agent.close-button': 'Lukk',
  'rovo-chat.view-agent.copy-instructions-label': 'Kopier',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Kopiinstruksjoner',
  'rovo-chat.view-agent.created-by-label': '<text>av</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'antall favoritter',
  'rovo-chat.view-agent.go-back-label': 'Gå tilbake',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Forge-agenter bygget med kode, har instruksjonene sine skjult av personvernshensyn.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Disse instruksjonene er private',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Forge-agenter bygget med kode, bruker ikke vanlige kunnskapskilder',
  'rovo-chat.view-agent.instructions-label': 'Instruksjoner',
  'rovo-chat.view-agent.knowledge-label': 'Kunnskap',
  'rovo-chat.view-agent.member-count': '{count, plural, one {{count,number} medlem} other {{count,number} medlemmer}}',
  'rovo-chat.view-agent.modal-title': 'Bla gjennom agenter',
  'rovo-chat.view-agent.no-actions': 'Ingen handlinger',
  'rovo-chat.view-agent.no-instruction-placeholder': 'Denne agenten har ingen egendefinerte instruksjoner',
  'rovo-chat.view-agent.no-knowledge-added': 'Ingen egendefinerte kunnskapskilder',
  'rovo-chat.view-agent.no-teams': 'Ikke en del av noen team',
  'rovo-chat.view-agent.open-chat-label': 'Åpen chat',
  'rovo-chat.view-agent.reactions-metadata-label': 'antall reaksjoner',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo-agent',
  'rovo-chat.view-agent.teams-label': 'Team',
  'rovo-chat.view-agent.users-metadata-label': 'antall brukere',
};
